const initState = {
	user: false,
	authenticated: false,
	initialState: 'false',
	isOnline: true,
	foundProspectus: false,
	justLoggedIn: false,
	justRegistered: false,
	didSave: false,
	failedSave: false,
	prospectusId: false,
	didLogOut: false,
	saveTrigger: null,
	isSaving: false,
	resetSuccessful: false,
	resetPasswordError: false,
	forgottenError: false,
	forgottenSuccess: false,
	logInErrors: false,
	registerErrors: false,
	visitedOverview: false,
	authStatus: 'pending',
};

const userReducer = (state = initState, action) => {
	switch (action.type) {
		case 'SET_USER':
			return {
				...state,
				user: action.payload,
				justLoggedIn: true,
			};
		case 'SET_VISITED_OVERVIEW':
			return {
				...state,
				visitedOverview: true,
			};
		case 'UNSET_USER':
			return {
				...state,
				user: false,
				authenticated: false,
				foundProspectus: false,
				initialState: 'false',
				prospectusId: false,
				didLogOut: true,
				selectedWayfinderAnswers: {},
			};
		case 'USER_LOGGED_IN':
			return {
				...state,
				authenticated: action.payload,
				authStatus: action.authStatus,
			};
		case 'UNSET_JUST_LOGGED_IN':
			return {
				...state,
				justLoggedIn: false,
			};
		case 'SET_ONLINE_STATUS':
			return {
				...state,
				isOnline: action.payload,
			};
		case 'SET_PROSPECTUS_ID':
			return {
				...state,
				prospectusId: action.payload,
			};
		case 'FOUND_PROSPECTUS':
			return {
				...state,
				foundProspectus: action.payload.data,
				prospectusId: action.payload.prospectusId,
				selectedWayfinderAnswers: action.payload.selectedWayfinderAnswers || {},
			};
		case 'DID_SAVE':
			return {
				...state,
				didSave: true,
				prospectusId: action.payload,
				saveTrigger: Date.now(),
			};
		case 'IS_SAVING':
			return {
				...state,
				isSaving: action.payload,
			};
		case 'FAILED_SAVE':
			return {
				...state,
				failedSave: action.payload,
			};
		case 'REMOVE_LOGGED_OUT':
			return {
				...state,
				didLogOut: false,
			};
		case 'FORGOTTEN_PASSWORD':
			return {
				...state,
				forgottenError: action.payload.error, // false or string
				forgottenSuccess: action.payload.success, // true / false
			};
		case 'LOGIN_SUCCESS':
			return {
				...state,
				loginSuccess: action.payload.success,
			};
		case 'FAILED_REGISTER':
			return {
				...state,
				registerErrors: action.payload,
			};
		case 'FAILED_USER_LOG_IN':
			return {
				...state,
				logInErrors: action.payload,
			};
		case 'SET_JUST_REGISTERED':
			return {
				...state,
				justRegistered: action.payload,
			};
		case 'SET_JUST_LOGGED_IN':
			return {
				...state,
				justRegistered: action.payload,
			};
		case 'RESET_PASSWORD':
			return {
				...state,
				resetSuccessful: action.payload.success, // true / false
				resetPasswordError: action.payload.error, // false or string
			};
		default:
			return { ...state };
	}
};

export default userReducer;
